import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NCRsHandoverContent from '../content/ncrsHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class NCRsHandover extends React.Component {
	static getTitle() {
		return 'Non Conformance Register';
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<NCRsHandoverContent report={report} />
		);
	}
}

NCRsHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	NCRsHandover, {
		title: 'Non Conformance Register',
		className: 'ncrs-handover'
	})
);
